import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title" }
const _hoisted_3 = { class: "dialog-custom__content form-custom" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-start"
}
const _hoisted_5 = {
  key: 1,
  class: "p-field"
}
const _hoisted_6 = {
  class: "p-field-label",
  for: "apartmentname"
}
const _hoisted_7 = {
  for: "apartmentname",
  class: "fs-13 label-error"
}
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-field-label" }
const _hoisted_10 = { class: "p-field" }
const _hoisted_11 = { class: "p-field-label" }
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = {
  class: "p-field-label",
  for: "apartmentname"
}
const _hoisted_14 = {
  for: "apartmentname",
  class: "fs-13 label-error"
}
const _hoisted_15 = { class: "p-field" }
const _hoisted_16 = {
  class: "p-field-label",
  for: "risername"
}
const _hoisted_17 = { class: "p-field" }
const _hoisted_18 = { class: "p-field-label" }
const _hoisted_19 = { style: {"margin":"0 0 1rem 0"} }
const _hoisted_20 = { class: "ml-auto" }
const _hoisted_21 = { class: "p-field-label" }
const _hoisted_22 = { class: "p-field-label mb-2" }
const _hoisted_23 = { class: "dialog-custom__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.isDialogVisible = $event)),
    onHide: _ctx.doHideDialog,
    modal: true,
    showHeader: false,
    closable: false,
    class: "dialog-custom"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", {
          style: [{"width":"450px"}, {height: _ctx.isEdit ? '400px' : '60vh'}]
        }, [
          (!_ctx.currentEntrancePlant.hasRiserInterface)
            ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                (!_ctx.isEdit && !_ctx.isBrfa)
                  ? (_openBlock(), _createBlock("div", _hoisted_4, [
                      _createVNode("label", null, _toDisplayString(_ctx.$t("AppResourceEP.ChooseApartmentsToAdd")), 1),
                      _createVNode(_component_NumberButtons, {
                        class: "ml-auto",
                        modelValue: _ctx.newApartments,
                        "min-value": 1,
                        "max-value": _ctx.availableApartments,
                        onIncrement: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newApartments++)),
                        onDecrement: _cache[2] || (_cache[2] = ($event: any) => (_ctx.newApartments--))
                      }, null, 8, ["modelValue", "max-value"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isEdit || _ctx.isBrfa)
                  ? (_openBlock(), _createBlock("div", _hoisted_5, [
                      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.inputLabel), 1),
                      _createVNode(_component_InputText, {
                        disabled: _ctx.isBrfa,
                        id: "apartmentname",
                        type: "text",
                        class: ["w-100", { 'input-error': !_ctx.isValidName }],
                        modelValue: _ctx.apartment.name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.apartment.name = $event))
                      }, null, 8, ["disabled", "modelValue", "class"]),
                      _createVNode("label", _hoisted_7, _toDisplayString(_ctx.invalidNameReason), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isBrfa)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                      _createVNode("div", _hoisted_8, [
                        _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("AppResourceEP.Riser")), 1),
                        _createVNode(_component_Dropdown, {
                          class: "w-100",
                          options: _ctx.building.risers,
                          disabled: _ctx.building.risers && _ctx.building.risers.length === 1,
                          optionLabel: "name",
                          optionValue: "riserId",
                          modelValue: _ctx.apartment.riserId,
                          "onUpdate:modelValue": [
                            _cache[4] || (_cache[4] = ($event: any) => (_ctx.apartment.riserId = $event)),
                            _ctx.updateApartment
                          ]
                        }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _createVNode("div", _hoisted_10, [
                        _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("AppResourceEP.Floor")), 1),
                        _createVNode(_component_Dropdown, {
                          class: "w-100",
                          options: _ctx.riserFloors,
                          disabled: _ctx.riserFloors.length === 1,
                          optionLabel: "floor.name",
                          optionValue: "floor.floorId",
                          modelValue: _ctx.apartment.floorId,
                          "onUpdate:modelValue": [
                            _cache[5] || (_cache[5] = ($event: any) => (_ctx.apartment.floorId = $event)),
                            _ctx.updateApartment
                          ]
                        }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.currentEntrancePlant.hasRiserInterface)
              ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (_ctx.isEdit)
                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("label", _hoisted_13, _toDisplayString(_ctx.inputLabel), 1),
                          _createVNode(_component_InputText, {
                            disabled: _ctx.isBrfa,
                            id: "apartmentname",
                            type: "text",
                            class: ["w-100", { 'input-error': !_ctx.isValidName }],
                            modelValue: _ctx.apartment.name,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.apartment.name = $event))
                          }, null, 8, ["disabled", "modelValue", "class"]),
                          _createVNode("label", _hoisted_14, _toDisplayString(_ctx.invalidNameReason), 1)
                        ]),
                        _createVNode("div", _hoisted_15, [
                          _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t("AppResourceEP.Riser")), 1),
                          _createVNode(_component_InputText, {
                            disabled: true,
                            id: "risername",
                            type: "text",
                            class: "w-100",
                            modelValue: _ctx.riser.name,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.riser.name = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _createVNode("div", _hoisted_17, [
                          _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("AppResourceEP.RiserInterface")), 1),
                          _createVNode(_component_Dropdown, {
                            class: "w-100",
                            options: _ctx.risersInterfaces,
                            disabled: _ctx.risersInterfaces.length === 1,
                            optionLabel: "name",
                            optionValue: "riserInterfaceId",
                            modelValue: _ctx.selectedInterfaceId,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedInterfaceId = $event))
                          }, null, 8, ["options", "disabled", "modelValue"])
                        ])
                      ], 64))
                    : (_ctx.isBrfa)
                      ? (_openBlock(), _createBlock(_component_ElScrollbar, {
                          key: 1,
                          style: {"margin":"0 -20px 0 0","padding":"0 20px 0 0"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.floorsInterfaceConfig, (floorConfig, floorIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: floorConfig.floor.floorId,
                                class: "p-field d-flex",
                                style: { marginBottom: floorIndex < _ctx.floorsInterfaceConfig.length - 1 ? '1.5rem' : '0' }
                              }, [
                                _createVNode("h6", _hoisted_19, _toDisplayString(floorConfig.floor.name), 1),
                                _createVNode("div", _hoisted_20, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(floorConfig.interfaceApartments, (interfaceAp) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: interfaceAp.interface.riserInterfaceId,
                                      class: "mb-2 d-flex flex-column",
                                      style: {"width":"250px"}
                                    }, [
                                      _createVNode("label", _hoisted_21, _toDisplayString(_ctx.getRiserName(_ctx.riser, interfaceAp.interface)), 1),
                                      _createVNode(_component_Dropdown, {
                                        options: _ctx.noAppartmentOptions(interfaceAp.interface),
                                        optionLabel: "label",
                                        optionValue: "value",
                                        modelValue: interfaceAp.numberOfApartments,
                                        "onUpdate:modelValue": ($event: any) => (interfaceAp.numberOfApartments = $event)
                                      }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                    ]))
                                  }), 128))
                                ])
                              ], 4))
                            }), 128))
                          ]),
                          _: 1
                        }))
                      : (_openBlock(true), _createBlock(_Fragment, { key: 2 }, _renderList(_ctx.currentRiserInterfaces, (riserInterface, key) => {
                          return (_openBlock(), _createBlock("div", {
                            key: key,
                            class: "p-field"
                          }, [
                            _createVNode("h6", null, _toDisplayString(_ctx.getInterfaceDescription(riserInterface.mode, key, _ctx.currentRiserInterfaces.length)), 1),
                            _createVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("AppResourceEP.NumberOfApartmentsUpper")) + ": ", 1),
                            _createVNode(_component_Dropdown, {
                              class: "w-100",
                              modelValue: riserInterface.numberOfApartments,
                              "onUpdate:modelValue": ($event: any) => (riserInterface.numberOfApartments = $event),
                              options: _ctx.noAppartmentOptions(riserInterface),
                              optionLabel: "label",
                              optionValue: "value"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                          ]))
                        }), 128))
                ], 64))
              : _createCommentVNode("", true)
        ], 4)
      ]),
      _createVNode("footer", _hoisted_23, [
        _createVNode(_component_Button, {
          class: "p-button-text mr-2",
          onClick: _ctx.handleHideDialog
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: _ctx.buttonSubmitLabel,
          onClick: _ctx.handleButtonSubmitAction,
          class: "p-button-rounded p-button-raised p-button--m",
          disabled: _ctx.saveButtonDisabled
        }, null, 8, ["label", "onClick", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "onHide"]))
}